import * as React from "react";
import { SVGProps } from "react";

const BeanCash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 310 331"
    {...props}
  >
    <defs>
      <linearGradient
        id="a"
        x1={2}
        x2={31}
        y1={169}
        y2={169}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#faac17" />
        <stop offset={1} stopColor="#ffd43b" />
      </linearGradient>
      <linearGradient
        xlinkHref="#a"
        id="c"
        x1={150}
        x2={251}
        y1={157}
        y2={157}
      />
      <linearGradient
        xlinkHref="#a"
        id="d"
        x1={150}
        x2={187}
        y1={272}
        y2={272}
      />
      <linearGradient
        id="b"
        x1={30}
        x2={185}
        y1={38}
        y2={299}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#96c859" />
        <stop offset={1} stopColor="#54911a" />
        <stop offset={1} stopColor="#357303" />
      </linearGradient>
      <linearGradient
        xlinkHref="#a"
        id="e"
        x1={89}
        x2={137}
        y1={162}
        y2={162}
      />
      <linearGradient xlinkHref="#b" id="f" x1={58} x2={213} y1={22} y2={282} />
      <linearGradient
        xlinkHref="#a"
        id="g"
        x1={86}
        x2={116}
        y1={276}
        y2={276}
      />
      <linearGradient xlinkHref="#a" id="h" x1={86} x2={97} y1={175} y2={175} />
      <linearGradient
        xlinkHref="#a"
        id="i"
        x1={244}
        x2={295}
        y1={214}
        y2={214}
      />
      <linearGradient
        xlinkHref="#a"
        id="j"
        x1={205}
        x2={239}
        y1={246}
        y2={246}
      />
      <linearGradient
        xlinkHref="#a"
        id="k"
        x1={258}
        x2={309}
        y1={293}
        y2={293}
      />
      <linearGradient
        xlinkHref="#a"
        id="l"
        x1={196}
        x2={248}
        y1={300}
        y2={300}
      />
      <linearGradient
        xlinkHref="#a"
        id="m"
        x1={130}
        x2={168}
        y1={310}
        y2={310}
      />
      <linearGradient
        xlinkHref="#a"
        id="n"
        x1={9}
        x2={15}
        y1={161}
        y2={161}
        gradientTransform="rotate(-175 12 161)"
      />
    </defs>
    <path
      fill="url(#a)"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M31 157s-18-15-29 5c0 0-2 4 3 6 0 0-5 16 20 19"
    />
    <path
      fill="url(#c)"
      d="M248 137s12 20-10 34a42 42 0 0 1-12 6c-6 1-17 5-20 18 0 0-5 15-18 23a29 29 0 0 1-29 2 24 24 0 0 1-8-7l-1-1c20-42 14-91 8-120h1s32 57 89 45z"
    />
    <path
      fill="url(#d)"
      d="M186 297a4 4 0 0 1 1 1 4 4 0 0 1-7 3c-20-16-16-38-16-38l-12 8-1-7v-9l-1-13 10 7 6 2a8 8 0 0 1 4 5z"
    />
    <path
      fill="url(#b)"
      d="M128 240h-1s-29 14-56 5c0 0-1 12 16 11h1l-1 16h-1c-26-7-26-30-26-30s-47-18-32-76c0 0 5-18 19-27 4-5-1-10-1-10-18-6-44-23-37-78a80 80 0 0 1 9-26 39 39 0 0 1 16-14c21-11 74-28 116 55a207 207 0 0 1 8 26c6 29 12 78-8 120a124 124 0 0 1-14 23c1 8 5 16 14 20h1v9h-4a13 13 0 0 1-12-8zm9-83-21-22c2 22-7 22-7 22-19-6-20 11-20 11s-10 14 8 13a4 4 0 0 1 0 1l6 6a3 3 0 0 0 3 0c14-4 12-24 12-24zm-14-15c11-12-4-24-4-24z"
    />
    <path
      fill="url(#e)"
      d="M97 181c0-1 0-8-8-13s1-17 20-11c0 0 9 0 7-22l21 22-19 7s2 20-12 24a3 3 0 0 1-3 0l-6-6a4 4 0 0 0 0-1z"
    />
    <path fill="url(#f)" d="M119 118s15 12 4 24z" />
    <path
      fill="url(#g)"
      d="M116 294c0 2-1 5-3 5a4 4 0 0 1-4 0c-11-7-19-25-19-25l-4 6 1-8 1-16v-2l8-1z"
    />
    <path fill="url(#h)" d="M89 168c8 5 8 12 8 13-18 1-8-13-8-13z" />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M119 118s15 12 4 24m7-31s20 19 3 41m-44 16s1-17 20-11c0 0 9 0 7-22l21 22-19 7s2 20-12 24a3 3 0 0 1-3 0l-6-6a4 4 0 0 0 0-1c0-1 0-8-8-13z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M89 168s-10 14 8 13"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M135 220a54 54 0 0 0 1 15c1 8 5 16 14 20"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m123 228 5 12 7 16a13 13 0 0 0 12 8h3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m151 264 1 7 12-8s-4 22 16 38a4 4 0 0 0 7-3 4 4 0 0 0-1-1l-16-41a8 8 0 0 0-4-4l-6-3-10-7 1 13zm-65 8c-26-7-26-30-26-30s-47-18-32-76c0 0 5-18 19-27a29 29 0 0 1 10-4m30 137-1 8 4-6s8 18 19 25a4 4 0 0 0 4 0c2 0 3-3 3-5l-20-41-8 1v2z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M127 240s-29 14-56 5c0 0-1 12 16 11M60 131a51 51 0 0 1-14-2c-18-6-44-23-37-78a80 80 0 0 1 9-26 39 39 0 0 1 16-14c21-11 74-28 116 55a207 207 0 0 1 8 26c6 29 12 78-8 120a124 124 0 0 1-14 23"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M46 129s5 5 1 10"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M159 92s32 57 89 45c0 0 12 20-10 34a42 42 0 0 1-12 6c-6 1-17 5-20 18 0 0-5 15-18 23a29 29 0 0 1-29 2 24 24 0 0 1-8-7"
    />
    <circle cx={61} cy={50} r={26} fill="#fff" />
    <circle cx={32} cy={74} r={16} fill="#fff" />
    <circle cx={51} cy={50} r={14} />
    <circle cx={29} cy={72} r={10} />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M164 146s20 6 32 25"
    />
    <path
      fill="url(#i)"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m244 187 51 55"
    />
    <path
      fill="url(#j)"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m205 228 34 36"
    />
    <path
      fill="url(#k)"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m258 267 51 53"
    />
    <path
      fill="url(#l)"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m196 272 52 56"
    />
    <path
      fill="url(#m)"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m130 290 38 40"
    />
    <path
      fill="url(#n)"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14 168s-5-3-4-14"
    />
    <ellipse
      cx={71}
      cy={112}
      fill="#c1272d"
      rx={5}
      ry={7}
      transform="rotate(-48 71 112)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={4}
      d="M56 110s21 4 23-19"
    />
  </svg>
);

export default BeanCash;
